document.addEventListener('turbolinks:load', function() {
  if(window.ga && ga.loaded) {
    gtag('config', 'UA-74187457-1')
  }
});

document.addEventListener("turbolinks:load", function(event) {

    // //scrolling for category mob
    // const anchorMob = document.getElementsByClassName("scroll-top")[0];

    // anchorMob.onclick = scrollToTop;

    // function scrollToTop() {
    //     window.scroll({
    //         top: 0,
    //         behavior: 'smooth'
    //     })
    // }

    const catalogDropdown = document.getElementsByClassName('catalog-sub-dropdown');
    const catalogRow = document.getElementsByClassName('catalog-sub-dropdown-row');

    for(let i = 0; i < catalogRow.length; i++){

        catalogRow[i].addEventListener("click",function(){

            if (catalogDropdown[i].childNodes[1].classList.contains('catalog-sub-dropdown-list-open')) {
                catalogDropdown[i].childNodes[1].classList.remove("catalog-sub-dropdown-list-open");
                catalogDropdown[i].classList.remove("catalog-sub-dropdown-open");
            } else {
                catalogDropdown[i].childNodes[1].classList.add("catalog-sub-dropdown-list-open");
                catalogDropdown[i].classList.add("catalog-sub-dropdown-open");
            }
        })
    }


    document.querySelector('.sort-wrapper').addEventListener('click', function() {
        this.querySelector('.sort-select').classList.toggle('open');
    })

    for (const option of document.querySelectorAll(".sort-option")) {
        option.addEventListener('click', function() {
            if (!this.classList.contains('selected')) {
                if( this.parentNode.querySelector('.sort-option.selected')) {
                    this.parentNode.querySelector('.sort-option.selected').classList.remove('selected');
                }
                this.classList.add('selected');
                this.closest('.sort-select').querySelector('.sort__trigger span').textContent = this.textContent;
            }
            // filterRequest();
        })
    }

    window.addEventListener('click', function(e) {
        const select = document.querySelector('.sort-select')
        if (!select.contains(e.target)) {
            select.classList.remove('open');
        }
    });


    //filter mob toggle
    const filterOpenBtn = document.getElementsByClassName("filter-open-mob")[0];
    const catalogSidebar = document.getElementsByClassName("catalog-sidebar-wrapper")[0];
    const wrapper = document.getElementsByClassName("wrapper")[0];
    const header = document.getElementsByClassName("header")[0];
    const closeCatalogMob = document.getElementsByClassName("close-sidebar")[0];

    filterOpenBtn.onclick = openMobFilter;
    closeCatalogMob.onclick = closeMobFilter;

    function openMobFilter() {
        catalogSidebar.classList.add("catalog-sidebar-wrapper-mob-open");
        wrapper.style["max-height"] = "100vh";
        header.style["z-index"] = "2";
    }

    function closeMobFilter() {
        catalogSidebar.classList.remove("catalog-sidebar-wrapper-mob-open");
        wrapper.removeAttribute("style");
        header.removeAttribute("style");
    }


    //Scripts for Modal

})
